import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';

import { asyncPopulateUser } from '../user/slice';

export interface AuthenticationState {
    isAuthenticated: boolean | null;
    email: string;
}

export const initialState: AuthenticationState = {
    isAuthenticated: null,
    email: '',
};

export const asyncLogInWithExistingSession = createAsyncThunk('authentication/login', async (payload, { dispatch }) => {
    try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const { email } = cognitoUser.attributes;
        const cognitoIdentityCredentials = await Auth.currentCredentials();
        const userId = cognitoIdentityCredentials.identityId.split(':')[1];
        dispatch(login({ email }));
        dispatch(asyncPopulateUser());

        datadogRum.setUser({
            id: userId,
        });

        datadogLogs.setUser({
            id: userId,
        });
    } catch (e) {
        if (e !== 'The user is not authenticated') {
            console.error(e);
        }

        dispatch(logout());
    }
});

export const logoutAndClearCaches = createAsyncThunk('authentication/logoutAndClear', async (payload, { dispatch }) => {
    // sign out with amplify
    await Auth.signOut();

    // reset login redirect
    localStorage.removeItem('login-redirect');
    // reset caches
    window.location.reload();
});

export const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        login: (state, action: PayloadAction<{ email: string }>) => {
            state.email = action.payload.email;
            state.isAuthenticated = true;
        },
        logout: () => ({
            ...initialState,
            isAuthenticated: false,
        }),
    },
});

export const { login, logout } = authenticationSlice.actions;

export default authenticationSlice.reducer;
